import React, { TextareaHTMLAttributes } from 'react';

import styles from '../Fields.module.css';

function TextArea({
  className = '',
  ref,
  ...fieldProps
}: TextareaHTMLAttributes<HTMLTextAreaElement> & { ref?: React.Ref<HTMLTextAreaElement> }) {
  return (
    <textarea
      ref={ref}
      className={`${styles.textAreaField} ${className}`}
      id={fieldProps?.name && !fieldProps?.id ? fieldProps?.name : fieldProps?.id}
      name={fieldProps?.id && !fieldProps?.name ? fieldProps?.id : fieldProps?.name}
      {...fieldProps}
    />
  );
}

export default TextArea;
